<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="one">
<h1>One</h1>
<p>I was one of the few that made it out alive. What is it to live? As I write this down, I know of few other living souls in this region. I know they are struggling, as I am. We live in historical times, a history to which we may now have become a footnote. How far have we fallen? We live like cave people now. In our filth. It’s been three months since any form of communication, and at that point the news was looking bad. It’s hard to believe.</p>
<p>We have nothing now. I have nothing now. Pencils and paper. I miss my children the most, but I don’t think about that too often.</p>
<p>Sometimes I consider giving in and ending it, but I made it through this far. Why stop now? There must be others, surely. Enough to start again. Surely. It’ll be decades, no, centuries to get it back.</p>
<p>All the scientists are dead. All the doctors.</p>
<p>I remember a few things from childhood, so distant now. I remember trying an orange for the first time when I was about three. I remember the back step of the house, my mother oﬀering me the piece of orange, the taste.</p>
<p>All of it, gone. We don’t even have children to pass any knowledge on to. But we know we’ll survive because the electric people told us. Before the grid went down, they told us. But they can’t be here without the grid.</p>
<p>How did we come to this? How were we, humans, defeated so easily? Are we like the dinosaurs, destined to be wiped out before we were even conceived? It’s hard to believe. It was always going to happen. That’s how I see it now.</p>
<p>How did it happen?</p>
<p>We have to go back, before the wars, before the electric people, before the grid going down, before the disease, before the sky falling.</p>
<p>Back to Wester Island.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?3d9269a3